import { adminUsersApiURL } from "API/urls/admin.api";
import { axiosInstance } from "configs/axios";

export const fetchUsersFromCompaniesApi = async (payload) => {
  try {
    const response = await axiosInstance.post(
      adminUsersApiURL.getUsersFromCompanies,
      {
        ...payload,
      }
    );
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
